module.exports = __webpack_public_path__ + "static/data-model-2-cf7907704aab3962e319d19d411e676c.png";